<script setup lang="ts">
/** Right-side detail panel with a scrim; closes on Escape, scrim click or the × button. */
import { onBeforeUnmount, onMounted } from 'vue'

defineProps<{ title: string }>()
const emit = defineEmits<{ close: [] }>()
const onKey = (e: KeyboardEvent) => e.key === 'Escape' && emit('close')
onMounted(() => document.addEventListener('keydown', onKey))
onBeforeUnmount(() => document.removeEventListener('keydown', onKey))
</script>

<template>
  <div class="scrim" @click="emit('close')" />
  <aside class="drawer" role="dialog" aria-modal="true" :aria-label="title">
    <header class="head">
      <h2>{{ title }}</h2>
      <button class="x" :aria-label="$t('common.close')" @click="emit('close')">×</button>
    </header>
    <slot />
  </aside>
</template>

<style scoped>
.scrim {
  position: fixed;
  inset: 0;
  z-index: 50;
  background: rgb(0 0 0 / 0.3);
}
.drawer {
  position: fixed;
  z-index: 60;
  top: 0;
  right: 0;
  bottom: 0;
  width: min(640px, 100vw);
  overflow-y: auto;
  padding: 1.25rem 16px 2rem;
  background: var(--bg-card);
  border-left: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
}
.head h2 {
  word-break: break-word;
}
.x {
  border: 0;
  background: none;
  color: var(--fg);
  font-size: 1.6rem;
  line-height: 1;
  cursor: pointer;
}
</style>
